import { createContext, ReactNode, useMemo } from 'react';
import { useAccessToken } from 'utils/auth';
import { useWorkPeriodsQuery } from '../query';
import { WorkPeriodsContextState } from '../types';

export const WorkPeriodsContext = createContext<
  WorkPeriodsContextState | undefined
>(undefined);

export const WorkPeriodsContextProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const { token } = useAccessToken();
  const { data, isLoading } = useWorkPeriodsQuery(token);

  const contextValue = useMemo(
    () => ({ workPeriods: data?.data, isLoading }),
    [data, isLoading]
  );

  return (
    <WorkPeriodsContext.Provider value={contextValue}>
      {children}
    </WorkPeriodsContext.Provider>
  );
};
